function Mouse(){

    this.build();

}

Mouse.prototype.build = function(){

    if( hasTouch ){
        return false;
    }

    this.isStuck = false;
    this.timer = null;
    this.initCursor();
    this.initHovers();

};

Mouse.prototype.initCursor = function() {
    const { Back } = window;
    this.innerCursor = document.querySelector(".circle-cursor--inner");
    this.innerCursorBox = this.innerCursor.getBoundingClientRect();
    this.outerCursor = document.querySelector(".circle-cursor--outer");
    this.outerCursorBox = this.outerCursor.getBoundingClientRect();
    this.outerCursorSpeed = 0;
    this.easing = Back.easeOut.config(1.7);
    this.clientX = -100;
    this.clientY = -100;
    this.showCursor = false;

    const unveilCursor = () => {
        gsap.set(this.innerCursor, {
            x: this.clientX,
            y: this.clientY
        });
        gsap.set(this.outerCursor, {
            x: this.clientX - this.outerCursorBox.width / 2,
            y: this.clientY - this.outerCursorBox.height / 2
        });
        setTimeout(() => {
            this.outerCursorSpeed = 0.2;
        }, 100);
        this.showCursor = true;
    };
    document.addEventListener("mousemove", unveilCursor);

    document.addEventListener("mousemove", e => {
        this.clientX = e.clientX;
        this.clientY = e.clientY;
    });

    const mouseUp = () => {
        clearInterval(this.timer);
    };
    document.addEventListener("mouseup", mouseUp);

    const render = () => {
        gsap.set(this.innerCursor, {
            x: this.clientX,
            y: this.clientY
        });
        if( !this.isStuck ){
            gsap.to(this.outerCursor, this.outerCursorSpeed, {
                x: this.clientX - this.outerCursor.getBoundingClientRect().width / 2,
                y: this.clientY - this.outerCursor.getBoundingClientRect().height / 2
            });
        }
        if (this.showCursor) {
            document.removeEventListener("mousemove", unveilCursor);
        }
        requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
};

Mouse.prototype.mouseLeave = function(){

    let that = this;

    that.isStuck = false;
    that.isTwentyTwenty = false;
    gsap.to(that.outerCursor, 0.2, {
        width: that.outerCursorOriginals.width,
        height: that.outerCursorOriginals.height,
        opacity: 0.2,
        borderColor: "#ffffff",
        borderWidth: "1px",
        backgroundColor: "transparent",
        borderRadius: "50%"
    });
    gsap.to(this.innerCursor, 0.2, {
        backgroundColor: "#ffffff",
        opacity: 1,
        width: 5,
        height: 5
    });

};

// const linkMouseEnter = e => {
Mouse.prototype.linkMouseEnter = function(e) {
    let that = this;
    that.isStuck = true;
    const target = e.currentTarget.querySelector(".link-icon");
    const box = target.getBoundingClientRect();
    that.killTweens();
    that.outerCursorOriginals = {
        width: that.outerCursorBox.width,
        height: that.outerCursorBox.height
    };
    gsap.to(that.outerCursor, 0.3, {
        x: box.left,
        y: box.top,
        width: box.width,
        height: box.height,
        opacity: 1,
        borderColor: "#CDAE82",
        borderWidth: "2px",
        backgroundColor: "transparent"
    });
    gsap.to(that.innerCursor, 0.2, {
        backgroundColor: "#fff"
    });
};

Mouse.prototype.sliderMouseEnter = function(e) {
    let that = this;
    that.isStuck = true;
    const box = e.target.getBoundingClientRect();
    that.outerCursorOriginals = {
        width: that.outerCursorBox.width,
        height: that.outerCursorBox.height
    };
    gsap.to(that.outerCursor, 0.2, {
        x: box.left,
        y: box.top,
        width: box.width,
        height: box.width,
        opacity: 1,
        borderColor: "#CDAE82"
    });
    gsap.to(that.innerCursor, 0.2, {
        backgroundColor: "#CDAE82",
        opacity: 0
    });
};

Mouse.prototype.twentytwentyMouseEnter = function(e) {
    let that = this;
    that.isTwentyTwenty = true;
    that.isStuck = true;
    that.target = e;
    const box = e.target.getBoundingClientRect();
    that.outerCursorOriginals = {
        width: that.outerCursorBox.width,
        height: that.outerCursorBox.height
    };
    gsap.to(that.outerCursor, 0.2, {
        x: box.left,
        y: box.top,
        width: box.width,
        height: box.width,
        opacity: 1,
        borderColor: "#CDAE82",
        borderWidth: "2px",
        zIndex: 1000
    });
};

Mouse.prototype.twentytwentyMouseDown = function(e) {
    let that = this;
    that.timer = setInterval(function(){
        let pos = $('.twentytwenty-handle').offset();
        gsap.to(that.outerCursor, that.outerCursorSpeed, {
            x: pos.left,
            y: pos.top
        });
    }, 50);
};

Mouse.prototype.killTweens = function(){
    gsap.killTweensOf( ".circle-cursor--outer" );
    gsap.killTweensOf( ".circle-cursor--inner" );
};

Mouse.prototype.initHovers = function() {

    let that = this;

    const defaultMouseEnter = e => {
        that.isStuck = true;
        const target = e.currentTarget;
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.2, {
            x: box.left,
            y: box.top,
            width: box.width,
            height: box.height,
            opacity: 1,
            borderColor: "#CDAE82",
            borderWidth: "1px"
        });
        gsap.to(that.innerCursor, 0.2, {
            backgroundColor: "#CDAE82"
        });
    };

    const defaultItems = document.querySelectorAll(".default-hover");
    defaultItems.forEach(item => {
        item.addEventListener("mouseenter", defaultMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const btnMouseEnter = e => {
        that.isStuck = true;
        const target = e.currentTarget.querySelector(".btn-circle");
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.2, {
            x: box.left,
            y: box.top,
            width: box.width,
            height: box.height,
            opacity: 1,
            borderColor: "#CDAE82",
            borderWidth: "2px"
        });
        gsap.to(that.innerCursor, 0.2, {
            backgroundColor: "#CDAE82"
        });
    };

    const btnItems = document.querySelectorAll(".btn");
    btnItems.forEach(item => {
        item.addEventListener("mouseenter", btnMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const linkItems = document.querySelectorAll(".hover-link");
    linkItems.forEach(item => {
        item.addEventListener("mouseenter", that.linkMouseEnter.bind(this));
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const gemMouseEnter = e => {
        const target = e.currentTarget.querySelector("img");
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.3, {
            width: 50,
            height: 50,
            // opacity: 0.2,
            backgroundColor: "#CDAE82"
        });
        gsap.to(that.innerCursor, 0.2, {
            backgroundColor: "#CDAE82"
        });
    };

    const gemItems = document.querySelectorAll(".hover-gem");
    gemItems.forEach(item => {
        item.addEventListener("mouseenter", gemMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const underlineMouseEnter = e => {
        that.isStuck = true;
        const target = e.currentTarget;
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.2, {
            x: box.left,
            y: box.top + box.height,
            width: box.width,
            height: 1,
            opacity: 1,
            borderColor: "#CDAE82",
            borderWidth: "0",
            borderRadius: "0",
            backgroundColor: "#CDAE82"
        });
        gsap.to(that.innerCursor, 0.2, {
            backgroundColor: "#CDAE82"
        });
    };

    const underlineItems = document.querySelectorAll(".underline-hover");
    underlineItems.forEach(item => {
        item.addEventListener("mouseenter", underlineMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const sliderItems = document.querySelectorAll(".single-jewel-slider-dots");
    sliderItems.forEach(item => {
        item.addEventListener("mouseenter", that.sliderMouseEnter.bind(this));
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const mainnavMouseEnter = e => {
        const target = e.currentTarget;
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.2, {
            width: 60,
            height: 60,
            backgroundColor: "#CDAE82"
        });
        gsap.to(that.innerCursor, 0.2, {
            opacity: 0,
            backgroundColor: "#CDAE82"
        });
    };

    const mainnavMouseEnterItems = document.querySelectorAll(".nav-main a, input[type='submit']");
    mainnavMouseEnterItems.forEach(item => {
        item.addEventListener("mouseenter", mainnavMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });

    const socialnavMouseEnter = e => {
        that.isStuck = true;
        const target = e.currentTarget.querySelector(".svg");
        const box = target.getBoundingClientRect();
        that.killTweens();
        that.outerCursorOriginals = {
            width: that.outerCursorBox.width,
            height: that.outerCursorBox.height
        };
        gsap.to(that.outerCursor, 0.2, {
            x: box.left,
            y: box.top,
            width: box.width,
            height: box.height,
            opacity: 0.8,
            borderColor: "#CDAE82"
        });
        gsap.to(that.innerCursor, 0.2, {
            backgroundColor: "#ffffff"
        });
    };

    const socialnavMouseEnterItems = document.querySelectorAll(".nav-social a");
    socialnavMouseEnterItems.forEach(item => {
        item.addEventListener("mouseenter", socialnavMouseEnter);
        item.addEventListener("mouseleave", that.mouseLeave.bind(this));
    });


};
